import React from "react";
function PreviewTab({ text, isAnotherStyle, children }) {
    return (React.createElement("div", { className: "preview-inner", style: { width: `${isAnotherStyle ? +"px" : "402px"}` } },
        text && React.createElement("div", { className: 'sub-cover', dangerouslySetInnerHTML: { __html: text } }),
        React.createElement("div", { className: "preview-contents" },
            React.createElement("div", { className: "input-box", style: { gap: isAnotherStyle ? '1px' : '8px' } }, children))));
}
;
export default React.memo(PreviewTab);
